module.exports = __webpack_public_path__ + "static/img/17-北京十二中朗悦学校1.06e1385.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/17-北京十二中朗悦学校1.png
// module id = uQot
// module chunks = 0